import React from "react";

const Select = ({ listOptions, onChangeSelect, pageSize }) => {

  return (
    <select onChange={onChangeSelect} value={pageSize}>
      {listOptions && listOptions.length > 0 ? (
        listOptions.map((opt, index) => <option key={index} value={opt}>{opt}</option>)
      ) : (
        <option value="10">10</option>
      )}
    </select>
  );
};

export default Select;
